import HelperService from "./HelperService";

const CommonFunction = {

  sortArrayBasedOnkey(array: any, key: any) {

    return array.sort(function (a: any, b: any) {
      var x = a[key];
      var y = b[key];
      // It compares these two values (x and y). If x is less than y, it returns -1 which means a should come before b. If x is greater than y,
      //  It returns 1 which means a should come after b. If they are equal, it returns 0 which means their order does not matter.
      return x < y ? -1 : x > y ? 1 : 0;
    });
  },


  checkFormEmptyFields(obj: any, crObj: any = null, excludedKeys: any = []) {
    let emptyKeyFlag = false;
    const excludedKeysSet = new Set(excludedKeys);

    Object.keys((crObj != null) ? crObj : obj).forEach((key) => {
      if (
        !excludedKeysSet.has(key) &&
        (obj[key] === undefined || !obj[key] || obj[key] === "")
      ) {
        emptyKeyFlag = true;
      }
    });
    return emptyKeyFlag;
  },
  addBadgesBasedOnStatus(status: string) {
    status = status?.toLowerCase();
    if (status === "INACTIVE" || status === "PENDING" || status === "DEBIT" || status === "REJECTED") {
      return `badge badge-pill badge-danger`;
    } else if (status === "ACTIVE" || status === "ACCEPTED" || status === "CREDIT") {
      return `badge badge-pill badge-primary`;
    }

  },
  getPaymentStatus(status: string) {
    if (status === "SUCCESS") {
      return `badge badge-pill badge-green`;
    } else {
      return `badge badge-pill badge-danger`;
    }
  },
  passwordValidation(value: string) {
    if (value && !/(?=^.{8,}$)((?=.*\d)(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/.test(value)) {
      return false
    }
    return true;
  }


};
export default CommonFunction;
